import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from '../Button';
import Icon from '../Icon';
import { getTranslation } from '../../providers/TranslationProvider';
import Bell from '../../svg/icons/bell.svg';
import ALLOWED_DOMAINS from '../../constants/allowedDomains';
import { sanitizeString } from '../../utils/sanitizeString';
import './AmexShopSmallBuyoutNotifyButton.scss';

class AmexShopSmallBuyoutNotifyButton extends React.Component {
  static displayName = 'AmexShopSmallBuyoutNotifyButton';

  static propTypes = {
    activeNotifications: PropTypes.shape({
      [PropTypes.number]: PropTypes.shape({
        name: PropTypes.string,
      }),
    }),
    Analytics: PropTypes.shape({
      event: PropTypes.func,
    }),
    className: PropTypes.string,
    clearFilterButton: PropTypes.node,
    lineLimit: PropTypes.number,
    serviceTypeId: PropTypes.number,
    onReservationSelect: PropTypes.func.isRequired,
    venueId: PropTypes.number.isRequired,
    availableServiceTypes: PropTypes.arrayOf(
      PropTypes.string
    ),
    shopSmallVenueCardEvents: PropTypes.shape({
      notify: PropTypes.string,
    }),
    shopSmallNofityMessage: PropTypes.string.isRequired,
    notifyBuyoutEventName: PropTypes.string,
  };

  static defaultProps = {
    activeNotifications: {},
    Analytics: {},
    className: '',
    clearFilterButton: undefined,
    lineLimit: null,
    serviceTypeId: null,
    availableServiceTypes: [],
    shopSmallVenueCardEvents: {},
    notifyBuyoutEventName: '',
  };

  state = {
    limitSlots: true,
    newNotifications: false,
  };

  componentDidMount() {
    window.addEventListener('message', this.onPostMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.onPostMessage);
  }

  setListRef = (list) => {
    this.list = list;
  };

  handleNotification = (notifications) => {
    const { newNotifications } = this.state;

    if (Object.values(notifications).every((notification) => notification === null)) {
      if (newNotifications === true) {
        this.setState({ newNotifications: false });
        return;
      }
      return;
    }
    this.setState({ newNotifications: true });
  }

  onPostMessage = (e) => {
    const { venueId } = this.props;

    if (!ALLOWED_DOMAINS.includes(e.origin)) {
      return;
    }

    if (e.data.event === 'onNotifySync') {
      if (e.data.venueId === venueId) {
        this.handleNotification(e.data.value);
      }
    }
  }

  onSelect = ({
    e, reservation, stId, notifyService,
  }) => {
    e.stopPropagation();

    const {
      Analytics,
      onReservationSelect,
      notifyBuyoutEventName,
    } = this.props;

    if (Analytics.event) {
      Analytics.event(notifyBuyoutEventName);
    }
    onReservationSelect(reservation, stId, notifyService);
  };

  getActiveNotifySet = () => {
    const {
      activeNotifications,
    } = this.props;

    const { newNotifications } = this.state;
    const activeNotifySet = Object.values(activeNotifications).some((notifies) => notifies !== null);
    return activeNotifySet || newNotifications;
  }

  renderNotify = () => {
    const {
      serviceTypeId,
      availableServiceTypes,
    } = this.props;

    const activeNotifySet = this.getActiveNotifySet();

    let translationKey = 'button_add_notify';
    let fallback = 'Notify';

    if (activeNotifySet) {
      translationKey = 'button_remove_notify';
      fallback = 'Notify on';
    }

    let notifyShiftId;

    if (availableServiceTypes[0]) {
      notifyShiftId = parseInt(availableServiceTypes[0], 10);
    }

    const { shopSmallNofityMessage } = this.props;
    const sanitizedShopSmallNotifyMessage = sanitizeString(shopSmallNofityMessage);

    return (
      <>
        <p
          className="AmexShopSmallBuyoutNotifyButton__notifyMessage"
          dangerouslySetInnerHTML={{
            __html: sanitizedShopSmallNotifyMessage,
          }}
        />
        <Button
          aria-label={getTranslation({ translationKey, fallback })}
          type="button"
          className={cx('AmexShopSmallBuyoutNotifyButton__notify', {
            'AmexShopSmallBuyoutNotifyButton__notify--active': activeNotifySet,
          })}
          onClick={(e) => this.onSelect({
            e, stId: serviceTypeId, notifyService: notifyShiftId,
          })}
          variant={activeNotifySet ? 'primary' : 'secondary'}
        >
          <Icon iconClass="bell" component={Bell} />
          {activeNotifySet
            ? <span className="notify-msg">Notify On</span>
            : <span className="notify-msg">Notify</span>}
        </Button>
      </>
    );
  };

  render() {
    const { className, clearFilterButton, lineLimit } = this.props;
    const { limitSlots } = this.state;
    return (
      <div
        ref={this.setListRef}
        className={cx('AmexShopSmallBuyoutNotifyButton', {
          unlimited: !limitSlots || lineLimit,
          [className]: className,
        })}
      >
        {this.renderNotify()}
        {clearFilterButton}
      </div>
    );
  }
}

export default AmexShopSmallBuyoutNotifyButton;
